import Vue from 'vue';
import Tree from 'primevue/tree';
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';

// Registrar componentes globalmente
Vue.component('Tree', Tree);
Vue.component('Badge', Badge);
Vue.component('InputText', InputText);

// Button já pode estar registrado em outro lugar, mas garantimos que esteja disponível
Vue.component('Button', Button); 